import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { IAddPaperMaterial } from "mobx-stores/_models/paper-inventory/paper-material";
import { number, string } from "yup";
import {
  getPaperPaperSpecificationTypeOptions,
  getPaperTypeOptions,
} from "../share";

export const getAddPaperMaterialSchema =
  (): ObjectSchemaType<IAddPaperMaterial> => ({
    code: {
      type: InputType.text,
      gridSize: 12,
      label: "Mã số",
      validattionYupSchema: string().trim().required().max(50),
    },
    typeSelect: {
      type: InputType.select,
      gridSize: 6,
      label: "Loại giấy",
      optionItems: getPaperTypeOptions(),
      validattionYupSchema: string().trim().required(),
    },
    type: {
      type: InputType.text,
      gridSize: 6,
      label: "",
      validattionYupSchema: string().trim().max(50),
      disabled: true,
    },
    gsm: {
      type: InputType.number,
      gridSize: 12,
      label: "GSM",
      validattionYupSchema: number().required(),
    },
    specificationTypeSelect: {
      type: InputType.select,
      gridSize: 6,
      label: "Quy cách giấy - dạng",
      validattionYupSchema: string().trim(),
      optionItems: getPaperPaperSpecificationTypeOptions(),
    },
    specificationType: {
      type: InputType.text,
      gridSize: 6,
      label: "",
      validattionYupSchema: string().max(255),
      disabled: true,
    },
    specificationSize: {
      type: InputType.number,
      gridSize: 6,
      label: "Quy cách giấy - khổ",
      validattionYupSchema: numberNanable(),
    },
    specificationLength: {
      type: InputType.number,
      gridSize: 6,
      label: "Quy cách giấy - dài",
      validattionYupSchema: numberNanable(),
    },
  });
